export const SET_COUPONS_LOADING = 'SET_COUPONS_LOADING'
export const SET_COUPONS = 'SET_COUPONS'
export const ADD_COUPONS = 'ADD_COUPONS'
export const EDIT_COUPONS = 'EDIT_COUPONS'
export const DELETE_COUPONS = 'DELETE_COUPONS'